export interface HTMLText {
  html: string;
}

export const HTMLTextGrapQLAttributes = `
  html
`;
